import { Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { setFolders, setFoldersForDecision } from '../state/actions';
import { FolderSelectionType } from './foldersDropdown.types';
import { listFoldersForDecision } from './foldersDropdown.api';

const mapDispatch = (dispatch: Dispatch, { docId }: { docId: string }) => ({
  async onLoad() {
    const folders = await listFoldersForDecision(docId);
    dispatch(setFolders(folders));
    dispatch(
      setFoldersForDecision(
        docId,
        folders.filter((folder: FolderSelectionType) => folder.selected),
      ),
    );
  },
});

export const Connect = connect(null, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
